import { Injectable } from '@angular/core';
import {SchoolClassData} from "../interfaces/school-class-data";
import {DataService} from "./data.service";
import {take} from "rxjs";
import {WatchDataService} from "./watch-data.service";

@Injectable({
  providedIn: 'root'
})
export class SchoolClassDataService {

  schoolClassDataCache: Map<number, SchoolClassData> = new Map();

  constructor(
    private data: DataService,
    private watchDataService: WatchDataService
  ) { }

  getSchoolClassById(id: number, forceUpdate = false): Promise<SchoolClassData> {
    return new Promise<SchoolClassData>((resolve, reject) => {
      if(!forceUpdate && this.schoolClassDataCache.has(id)) {
        const data = this.schoolClassDataCache.get(id);
        if(data) {
          resolve(data);
        }
      } else {
        this.data.getSchoolClassById(id).pipe(take(1)).subscribe((response) => {
          if(response) {
            const mappedData = this.mapSchoolClassDataObject(response);
            this.schoolClassDataCache.set(id, mappedData);
            resolve(mappedData);
          } else {
            throw new Error(`Error getSchoolClassById: ${id} not found`);
          }
        })
      }
    })
  }

  getSchoolClasses(): Promise<SchoolClassData[]> {
    return new Promise<SchoolClassData[]>((resolve, reject) => {
      this.watchDataService.getSchoolClassesByUserSubject.subscribe((response) => {
        if(response && response.length) {
          resolve(response.map((sc: any) => this.mapSchoolClassDataObject(sc)));
        }
        resolve([]);
      });
    })
  }

  getDummySchoolClassData(): SchoolClassData {
    return {
      id: 1234,
      name: 'Dummy Name',
      classCode: "AHAH",
      numberStudents: 12345,
      grade: {
        id: "id",
        name: "string"
      },
      classNumber: "3",
      classAddition: "HA",
      createdAt: "01.01.2014",
      teachers: [],
      schoolClassYear: {
        id: -1,
        endYear: 0, // TODO: check if this is correct
        startYear: 0
      }
    }
  }

  mapSchoolClassDataObject(obj: any): SchoolClassData {
    const school = obj.school;

    return {
      id: obj.id ?? -1,
      name: obj.name ?? "",
      schoolName: school.name ?? "",
      classCode: obj.classCode ?? "",
      numberStudents: obj.numberStudents ?? 0,
      grade: {
        id: obj.grade?.id ?? "-1",
        name: obj.grade?.name ?? ""
      },
      classNumber: obj.classNumber ?? "",
      classAddition: obj.classAddition ?? "",
      createdAt: obj.createdAt ?? "01.01.2014",
      schoolClassYear: {
        id: obj.schoolClassYear?.id ?? -1,
        endYear: obj.schoolClassYear?.endYear ?? -1,
        startYear: obj.schoolClassYear?.startYear ?? -1
      },
      teachers: obj.teachers ?? []
    }
  }
}
